export class Routes {
  private static Url = '';

  public static get baseUrl(): string {
    return this.Url;
  }
  public static get emailOtp(): string {
    return this.baseUrl + '/otp';
  }
  public static get signIn(): string {
    return this.baseUrl + '/auth/signin';
  }
  public static get addProperty(): string {
    return this.baseUrl + '/vendor/add-property';
  }
  public static get userInfo(): string {
    return this.baseUrl + '/user/info';
  }
  public static get userSecurity(): string {
    return this.baseUrl + '/user/security';
  }
  public static get userProperties(): string {
    return this.baseUrl + '/user/properties';
  }
  public static get userWishlist(): string {
    return this.baseUrl + '/user/wishlist';
  }
  public static get userReviews(): string {
    return this.baseUrl + '/user/reviews';
  }
  public static get userNotifications(): string {
    return this.baseUrl + '/user/notifications';
  }
  public static get userTickets(): string {
    return this.baseUrl + '/user/tickets';
  }
  public static get userTours(): string {
    return this.baseUrl + '/user/scheduled-tours';
  }
  public static get userChat(): string {
    return this.baseUrl + '/user/chat';
  }
  public static get userKyc(): string {
    return this.baseUrl + '/kyc';
  }
  public static get rentalDashboard(): string {
    return this.baseUrl + '/rentals/rental-dashboard';
  }
  public static get listMyHomeForRent(): string {
    return this.baseUrl + '/rentals/list-my-home-for-rent';
  }
  public static get agentDashboard(): string {
    return this.baseUrl + '/agent/dashboard';
  }
  public static get agentChat(): string {
    return this.baseUrl + '/agent/chat';
  }
  public static get agentLeads(): string {
    return this.baseUrl + '/agent/leads';
  }
  public static get agentAppointments(): string {
    return this.baseUrl + '/agent/appointments';
  }
  public static get agentPortfolio(): string {
    return this.baseUrl + '/agent/portfolio';
  }

  public static get agentPayroll(): string {
    return this.baseUrl + '/agent/payroll';
  }

  public static get agentOffMarketProperties(): string {
    return this.baseUrl + '/agent/off-market-properties';
  }

  public static get agentEditOffmarketProperty(): string {
    return this.baseUrl + '/agent/edit-off-market-property';
  }

  public static get offMarketProperty(): string {
    return this.baseUrl + '/off-market-property';
  }

  public static get agentAccount(): string {
    return this.baseUrl + '/agent/account';
  }
  public static get agentTickets(): string {
    return this.baseUrl + '/agent/tickets';
  }
  public static get agentQueries(): string {
    return this.baseUrl + '/agent/queries';
  }

  public static get search(): string {
    return this.baseUrl + '/search';
  }

  public static get signOut(): string {
    return this.baseUrl + '/auth/signin';
  }
}
